import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '../views/Store.vue'
import Pay from '../views/Pay.vue'
import Finish from '../views/Finish.vue'
import Agreement from '../views/agreement/index.vue'
// import ScrollPanel from '../views/ScrollPanel.vue'
Vue.use(VueRouter)
const routes = [{
        path: '/',
        // redirect: '/store'
    },
    {
        path: '/store',
        name: 'store',
        component: Store
    },
    {
        path: '/pay',
        name: 'pay',
        component: Pay
    },
    {
        path: '/finish',
        name: 'finish',
        component: Finish
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: Agreement
    },
    //  {
    //     path: '/scroll',
    //     name: 'scroll',
    //     component: ScrollPanel
    // },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router